import { render, staticRenderFns } from "./ExternalRedEnvelope.vue?vue&type=template&id=00505bae&"
import script from "./ExternalRedEnvelope.vue?vue&type=script&lang=ts&"
export * from "./ExternalRedEnvelope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports